import React, { type RefObject } from 'react';
import { PROMO_ID } from 'reactApp/appHelpers/featuresHelpers/features/vigboPrintFakedoor';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { type ETooltipPlacement, ETooltipAppearance, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { markFakedoorCompleted } from 'reactApp/ui/VigboPrintFakedoor/utils';
import { renderVigboPrintModal } from 'reactApp/ui/VigboPrintFakedoor/VigboPrintModal/VigboPrintModal';
import { createDwhTemplatedSender } from 'reactApp/utils/dwh';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import styles from './VigboPrintTooltip.css';

interface VigboPrintTooltipProps {
    target: RefObject<HTMLElement>;
    placement: ETooltipPlacement;
    place: string;
}

const TOOLTIP_KEY = `${PROMO_ID}-tooltip`;

const sendRadar = createDwhTemplatedSender({ eventCategory: 'vigbo_tooltip', replacementSymbol: '_' });

export const VigboPrintTooltip = ({ target, placement, place }: VigboPrintTooltipProps) => {
    const key = TOOLTIP_KEY + place;

    const isDarkTheme = isDarkThemeModeEnabled();

    const onShow = () => {
        sendRadar({ action: 'fakedoor_show' });
    };

    const onClose = () => {
        sendRadar({ action: 'fakedoor_close' });
        storeHelper.setValue(key, true);
    };

    const onClick = () => {
        markFakedoorCompleted();
        renderVigboPrintModal();
        sendRadar({ action: 'fakedoor_click' });
    };

    if (storeHelper.getValue(key)) {
        return null;
    }

    return (
        <FloatingTooltip
            target={target}
            appearance={ETooltipAppearance.blueContrast}
            placement={placement}
            size={ETooltipSize.large}
            contentClassName={styles.content}
            title="Сделайте из снимков фотокнигу"
            text="Выберите снимки, которые хотите подержать в руках"
            img={`${cdnPackagesUrl}/static/cloud/vigbo/print/fakedoor/tooltip${isDarkTheme ? '-dark' : '-light'}.webp`}
            imageWidth={180}
            buttonText="Попробовать"
            buttonFitContent
            onClick={onClick}
            onClose={onClose}
            onShow={onShow}
            usePortal
        />
    );
};
